export default __webpack_public_path__ + "static/media/main logo.b2259599.png";